export default {
    namespaced: true,
    state: {
        project: null,
        isLoadingProjects: false,
    },
    actions: {
        saveProject({ commit }, project) {
            commit('SET_PROJECT', project);
        },
        
        // Add setCurrentProject action
        setCurrentProject({ commit }, project) {
            commit('SET_PROJECT', project);
        },
        
        // Add updateProjectInStore action
        updateProjectInStore({ commit }, updatedProject) {
            commit('SET_PROJECT', updatedProject);
        },
        
        // Add resetProjectState action
        resetProjectState({ commit }) {
            // Optionally clear or reset relevant parts of the state
            // For now, we'll just clear the project
            commit('SET_PROJECT', null);
        },
        
        async loadProjectData({ commit, dispatch, state }) {
            if (state.isLoadingProjects) return;
            
            commit('setIsLoadingProjects', true);
            
            try {
                await dispatch('common/loadAllData', null, { root: true });
            } catch (error) {
                console.error('Error loading project data:', error);
            } finally {
                commit('setIsLoadingProjects', false);
            }
        },
    },
    mutations: {
        SET_PROJECT(state, project) {
            state.project = project;
        },
        setIsLoadingProjects(state, isLoading) {
            state.isLoadingProjects = isLoading;
        },
    },
    getters: {
        getProject: state => state.project,
    }
};
